import React, { useState, useEffect } from 'react'
import cssMainBG from './MainBG.module.scss'

import {LoadingMask, AlertWindow, CredentialMultiInWindow, GlobalLibs} from 'bc-react-package'


// #region Member Variables
let mblnInitialized = false
// #endregion Member Variables


const COMP_NAME = "MainBG"

function MainBG(props)
{
    console.log(COMP_NAME + ".Begin: ", props)
    
    // #region Init State
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    const [showCredentialMultiIn, setShowCredentialMultiIn] = useState(false)
    const [credentialMultiInArguments, setCredentialMultiInArguments] = useState(null)
    // #endregion Init State
    
    // #region First Launch
    if (!mblnInitialized)
    {
        mblnInitialized = true
    } // end of if (!mblnInitialized)

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        let objWindowRefs = {
            OpenLoadingMask: OpenLoadingMask,
            CloseLoadingMask: CloseLoadingMask,
            ShowAlert: ShowAlert,
            ShowCredentialMultiInWindow: ShowCredentialMultiInWindow
        }
        // AAALibs.RegisterCallerWindownFuncRefs(objWindowRefs)
        GlobalLibs.RegisterCallerWindownFuncRefs(objWindowRefs)

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            // AAALibs.UnRegisterCallerWindownFuncRefs()
            GlobalLibs.UnRegisterCallerWindownFuncRefs()
            
            mblnInitialized = false
        }
    }, [props.location.pathname]) // end of useEffect
    
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask
    
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask
    
    function ShowAlert(AlertObject)
    {
        console.log(COMP_NAME + ".ShowAlertMain")
        setAlertObject(AlertObject)
        setShowAlert(true)
    }

    function HideAlert()
    {
        console.log(COMP_NAME + ".HideAlert")
        setAlertObject(null)
        setShowAlert(false)
    }

    /*===========================================
    summary: 開啟 多重登入 阻擋視窗
    remarks: 000 Tim 2022/11/02 Create
    ===========================================*/
    function ShowCredentialMultiInWindow(Title, Message)
    {
        let objCredentialMultiInArguments = {
            "Title": Title,
            "Message": Message
        }
        setCredentialMultiInArguments(objCredentialMultiInArguments)
        setShowCredentialMultiIn(true)
    } // end of ShowCredentialMultiInWindow

    
    function RenderMainWrapper()
    {
        return (
            <>
                <div className={cssMainBG.divBG}/>
                
                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert}/>
                <CredentialMultiInWindow ShowCredentialMultiIn={showCredentialMultiIn} 
                        CredentialMultiInArguments={credentialMultiInArguments}/>
            </>
        )
    }
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
}
export default MainBG